/**
 * 문의/교육 신청 폼의 정적 미리보기.
 * 폼은 사이트 방문자 입력용이라 편집 대상이 아니며, 레이아웃 재현을 위해 비활성 상태로 표시합니다.
 */

export function ContactFormPreview() {
  return (
    <form noValidate onSubmit={(e) => e.preventDefault()}>
      <p className="fg-heading">이름</p>
      <div className="f-row">
        <div className="fg">
          <label>성 <span>(필수)</span></label>
          <input type="text" disabled />
        </div>
        <div className="fg">
          <label>이름 <span>(필수)</span></label>
          <input type="text" disabled />
        </div>
      </div>
      <div className="fg">
        <label>휴대폰 번호 <span>(필수)</span></label>
        <input type="tel" disabled />
      </div>
      <div className="fg">
        <label>이메일 <span>(필수)</span></label>
        <input type="email" disabled />
      </div>
      <div className="fg">
        <label>문의 내용 <span>(필수)</span></label>
        <textarea disabled />
      </div>
    </form>
  );
}

export function EducationFormPreview() {
  return (
    <form noValidate onSubmit={(e) => e.preventDefault()}>
      <p className="fg-heading">신청 정보</p>
      <div className="f-row">
        <div className="fg">
          <label>성명 <span>(필수)</span></label>
          <input type="text" disabled />
        </div>
        <div className="fg">
          <label>휴대폰번호 <span>(필수)</span></label>
          <input type="tel" disabled />
        </div>
      </div>
      <div className="fg">
        <label>이메일 <span>(필수)</span></label>
        <input type="email" disabled />
      </div>
      <div className="f-row">
        <div className="fg">
          <label>인원수 <span>(선택)</span></label>
          <input type="text" placeholder="신청 인원" disabled />
        </div>
        <div className="fg">
          <label>업체명 <span>(선택)</span></label>
          <input type="text" disabled />
        </div>
      </div>
      <div className="fg">
        <label>문의사항 <span>(선택)</span></label>
        <textarea rows={6} disabled />
      </div>
    </form>
  );
}
